<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="color"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z"
    />
    <path
      :fill="color"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.293 15.7072L10.293 11.7072L11.7072 10.293L15.7072 14.293C16.0977 14.6835 16.0977 15.3167 15.7072 15.7072C15.3167 16.0977 14.6835 16.0977 14.293 15.7072Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSearch",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
